<template>
  <div v-if="!howCategoryRatingPresenter.hasData.value" class="w-full h-full flex justify-center items-center">
    {{ $t('message.noData') }}
  </div>
  <VueApexCharts
    v-else
    height="100%"
    :options="howCategoryRatingPresenter.chartOptions.value"
    :series="howCategoryRatingPresenter.chartSeries.value"
    type="radar"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { dashboardTargetColor, howCategoryRatingChartColor } from '@/domain/value_objects/color/ColorList'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useHowCategoryRatingPresenter } from '@/presentation/composables/dashboard/useHowCategoryRatingPresenter'

export default defineComponent({
  components: { VueApexCharts },
  setup(props, ctx) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const howCategoryRatingPresenter = useHowCategoryRatingPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const initChart = () => {
      howCategoryRatingPresenter.initChart(
        dashboardModalStatePresenter.dashboardUserList.value,
        howCategoryRatingChartColor,
        dashboardTargetColor,
        dashboardModalStatePresenter.dashboardProgramLanguage.value,
        displayLanguage.value,
        isLightMode()
      )
    }

    onMounted(() => {
      //  initChart()
    })

    return {
      initChart,
      howCategoryRatingPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
